var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatWeDo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.54,
    height: 13.792,
    viewBox: "0 0 13.54 13.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#094674;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.968 1.058)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M874.266,584.255a.307.307,0,0,1-.246-.124l-6.9-9.276-1.2,7.509a.307.307,0,1,1-.606-.1l1.318-8.227a.307.307,0,0,1,.549-.135l.051.069,4.924,3.654,2.959-4.339a.307.307,0,0,1,.559.2l-1.1,10.486a.307.307,0,0,1-.305.275ZM868.5,575.68l5.545,7.454.891-8.494-2.454,3.6a.307.307,0,0,1-.436.074Z",
    transform: "translate(-865.306 -573.156)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.969 5.572)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M874.266,613.872a.3.3,0,0,1-.057-.005l-8.652-1.633a.307.307,0,0,1-.112-.557L872,607.338a.307.307,0,0,1,.459.154l2.094,5.971a.307.307,0,0,1-.29.408Zm-7.853-2.1,7.387,1.394-1.788-5.1Z",
    transform: "translate(-865.307 -607.287)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.287 1.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M875.58,578.012a.307.307,0,0,1,0-.614l8.779-.075h0a.307.307,0,0,1,0,.614l-8.779.075Z",
    transform: "translate(-875.273 -577.324)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.713)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.802,
    cy: 1.802,
    r: 1.802
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.942)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.275,
    cy: 2.275,
    r: 2.275
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.986 9.908)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.942,
    cy: 1.942,
    r: 1.942
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.458 4.536)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.854 0.047)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDo);
export default __webpack_public_path__ + "static/media/WhatWeDo.7122bfa8daec28ed428de5b5b904d674.svg";
export { ForwardRef as ReactComponent };